import { referralShareCodeMutation } from "@/admin/accounts/accountsQuery.ts";
import type { GQAccountItem } from "@/admin/accounts/AccountsTable.tsx";
import { AdminModalButton } from "@/admin/AdminModalButton.tsx";
import { AInput } from "@/admin/form/Fields.tsx";
import { controllerProps, formPropsToAriaProps } from "@/components/forms/ariaController.tsx";
import { WModalForm } from "@/components/forms/WModalForm.tsx";
import { WTextField } from "@/components/forms/WTextField.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { Controller, useForm, type SubmitHandler } from "react-hook-form";

interface ReferralShareCodeModalProps {
    item: GQAccountItem;
    value: string;
}

interface ReferralShareCodeInputs {
    code: string;
}

export function ReferralShareCodeButton(props: ReferralShareCodeModalProps) {
    return (
        <AdminModalButton label={props.value} isDeleted={props.item.is_deleted}>
            <ReferralShareCodeModalContent {...props} />
        </AdminModalButton>
    );
}

function ReferralShareCodeModalContent({ item, value }: ReferralShareCodeModalProps) {
    const modifyMutation = useStandardMutation(referralShareCodeMutation);
    const { id } = item;

    const onSubmit: SubmitHandler<ReferralShareCodeInputs> = async (inputs) => {
        const { code } = inputs;

        await modifyMutation.mutateAsync({
            body: {
                billing_account_id: Number(id),
                code,
            },
        });
    };

    const form = useForm<ReferralShareCodeInputs>({
        mode: "onBlur",
        reValidateMode: "onBlur",

        defaultValues: {
            code: String(value),
        },
    });

    const { control } = form;

    return (
        <WModalForm form={form} onSubmit={onSubmit} title="Update referral share code" label="Update">
            <Controller
                control={control}
                name="code"
                {...controllerProps({ isRequired: true })}
                render={(props) => (
                    <WTextField
                        {...formPropsToAriaProps(props)}
                        headless
                        block
                        autoFocus
                        className="max-w-24rem"
                        wide
                        isRequired
                        label="Referral share code"
                    >
                        <AInput />
                    </WTextField>
                )}
            />
        </WModalForm>
    );
}
